export var getProductDetailsFromElement = function(element) {
    var _element_getAttribute;
    var productToken = (_element_getAttribute = element.getAttribute("data-product-token")) !== null && _element_getAttribute !== void 0 ? _element_getAttribute : "";
    var _element_getAttribute1;
    var promotedBy = (_element_getAttribute1 = element.getAttribute("data-product-promoted-by")) !== null && _element_getAttribute1 !== void 0 ? _element_getAttribute1 : "";
    var _element_getAttribute2;
    var impressionId = (_element_getAttribute2 = element.getAttribute("data-product-impression-id")) !== null && _element_getAttribute2 !== void 0 ? _element_getAttribute2 : "";
    return {
        productToken: productToken,
        promotedBy: promotedBy,
        impressionId: impressionId
    };
};
